// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".em-heading-separator{background-color:#ade0df;width:64px;height:2px;margin:unset}", ""]);
// Exports
module.exports = exports;
